import QueryString from 'querystring'

export const qps_from_search = (router_search) =>
  router_search ? QueryString.parse(router_search.substring(1)) : {}
